import React, { useCallback } from 'react';
import { Dialog, DialogContent } from '@material-ui/core';
import { FormValues, DirectoryForm } from './DirectoryForm';
import { dirsActions } from '../../../../../modules/dirs/actions';
import { useDispatch } from 'react-redux';
import { useCurrentDir } from '../../../../../modules/ui/hooks';
import { ModalClose } from '../../../../../components';
import { useShouldModalBeFullscreen } from '../../../../../utils/media-query';

interface Props {
  open: boolean;
  onClose: () => void;
}

export const AddDirectoryModal = ({ open, onClose }: Props) => {
  const dispatch = useDispatch();
  const fullScreen = useShouldModalBeFullscreen();
  const { currentDirId } = useCurrentDir();
  const onSubmit = useCallback(
    (values: FormValues) => {
      dispatch(
        dirsActions.create.trigger({
          ...values,
          parent: currentDirId
        })
      );
    },
    [dispatch, currentDirId]
  );

  return (
    <Dialog
      aria-labelledby="user-modal"
      open={open}
      onClose={onClose}
      fullWidth
      fullScreen={fullScreen}
      maxWidth="sm">
      <DialogContent>
        <ModalClose onClose={onClose} />
        <DirectoryForm onCancel={onClose} onSubmit={onSubmit} />
      </DialogContent>
    </Dialog>
  );
};
